import throttleUtility from "javascripts/modules/util.throttle.js";

class VisibilityState {
  constructor() {
    this.elements = document.querySelectorAll("[data-visibility]");
    this.visibleEvent = null;
    this.invisibleEvent = null;
    this._init();
  }

  _init() {
    document.addEventListener("DOMContentLoaded", event => {
      this._initEvents();
      this._checkVisibility();

      window.addEventListener(
        "scroll",
        throttleUtility(() => this._checkVisibility(), 500)
      );
    });
  }

  _initEvents() {
    this.visibleEvent = document.createEvent("Event");
    this.invisibleEvent = document.createEvent("Event");
    this.visibleEvent.initEvent("visible", true, true);
    this.invisibleEvent.initEvent("invisible", true, true);
  }

  _checkVisibility() {
    for (const element of this.elements) {
      const dataVisibility = element.getAttribute("data-visibility");

      if (this._isVisible(element) && dataVisibility !== "visible") {
        this._setVisibility(element, "visible", this.visibleEvent);
      } else if (!this._isVisible(element) && dataVisibility !== "invisible") {
        this._setVisibility(element, "invisible", this.invisibleEvent);
      }
    }
  }

  _isVisible(element) {
    const rect = element.getBoundingClientRect();
    const testVisibility =
      rect.bottom >= 0 &&
      rect.left >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight);
    return testVisibility;
  }

  _setVisibility(element, state, event) {
    element.setAttribute("data-visibility", state);
    element.dispatchEvent(event);
  }
}

export const visibilityState = new VisibilityState();
